import React from 'react';

function SupportPage() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Support</h1>
        <p>Get in touch with us</p>
      </div>

      <div className="page-content">
        <h2>Contact Information</h2>
        <p>
          We're here to help! If you have any questions, issues, or feedback about our apps, please reach out to us using any of the methods below.
        </p>

        <div className="contact-cards">
          <div className="contact-card">
            <h3>📧 Email</h3>
            <p>For general inquiries and support:</p>
            <a href="mailto:contact@music4fun.net" className="contact-link">
              contact@music4fun.net
            </a>
          </div>

          <div className="contact-card">
            <h3>📍 Mailing Address</h3>
            <p>Send us your feedback or reports:</p>
            <div className="address-block">
              <p>
                Music4Fun LLC<br />
                5900 Balcones Drive STE 100<br />
                Austin, TX 78731<br />
                United States
              </p>
            </div>
          </div>

          <div className="contact-card">
            <h3>🕐 Response Time</h3>
            <p>We typically respond to inquiries within 24-48 hours during business days.</p>
          </div>
        </div>

        <h2>Frequently Asked Questions</h2>
        
        <h3>How do I report a bug?</h3>
        <p>
          If you encounter any issues with our apps, please email us at <a href="mailto:contact@music4fun.net" className="inline-link">contact@music4fun.net</a> with a detailed description of the problem, including which app and device you're using.
        </p>

        <h3>How can I suggest a feature?</h3>
        <p>
          We love hearing from our users! Send us your feature requests and suggestions at <a href="mailto:contact@music4fun.net" className="inline-link">contact@music4fun.net</a>. We review all suggestions and incorporate the most requested features into future updates.
        </p>

        <h3>I need help using one of your apps</h3>
        <p>
          Each of our apps comes with built-in help and tutorials. You can also reach out to us at <a href="mailto:contact@music4fun.net" className="inline-link">contact@music4fun.net</a> and we'll be happy to assist you.
        </p>

        <h3>Where can I find the latest app updates?</h3>
        <p>
          All our apps are available on the Apple App Store and Google Play Store. New updates are released regularly with bug fixes, performance improvements, and new features. Enable automatic updates in your device settings to always have the latest version.
        </p>

        <h3>Do you have social media?</h3>
        <p>
          Connect with us for the latest news and updates about our apps. You can reach out to us directly at <a href="mailto:contact@music4fun.net" className="inline-link">contact@music4fun.net</a> if you have questions or feedback.
        </p>

        <h2>Need Something Else?</h2>
        <p>
          If your question wasn't answered above, feel free to contact us directly. Our support team is here to help with any concerns or questions you may have about our apps and services.
        </p>
      </div>
    </div>
  );
}

export default SupportPage;
